import { createSelector } from '@reduxjs/toolkit';

const selectAct = (state) => state.act;

export const selectDuplicatedInfo = () => createSelector(selectAct, (actState) => actState.duplicatedInfo);

export const selectWatchedActs = () => createSelector(selectAct, (actState) => actState.watchedActs);

export const selectGlobalMessage = () => createSelector(selectAct, (actState) => actState.globalMessage);
